define('services/voicemailService',[
    'services/apiCore'
], function (
    apiCore
) {
    'use strict';

    var BASE_URI = '/voicemail/messages/';

    var voicemailService = {
        getVoicemail: function (voicemailId) {
            return apiCore.v2.get(BASE_URI + voicemailId);
        },

        getVoicemailMedia: function (voicemailId, formatId) {
            var parameters = {};
            if (formatId) {
                parameters.formatId = formatId;
            }
            return apiCore.v2.get(BASE_URI + voicemailId + '/media', parameters);
        },

        deleteVoicemail: function (voicemailId) {
            return apiCore.v2.patch(BASE_URI + voicemailId, {
                deleted: true,
                deleteRetentionPolicy: {
                    voicemailRetentionPolicyType: 'IMMEDIATE_DELETE'
                }
            });
        },

        updateVoicemailRetention: function (voicemailId, deleteRetentionPolicy) {
            return apiCore.v2.patch(BASE_URI + voicemailId, {
                deleteRetentionPolicy: deleteRetentionPolicy
            });
        }
    };
    return voicemailService;
});

